module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "member"
  }, [_c('Avatar', {
    attrs: {
      "size": "small",
      "gender": _vm.gender,
      "photo": _vm.photo,
      "asCurator": _vm.asCurator
    }
  }), _c('div', {
    staticClass: "member__info"
  }, [_c('p', {
    staticClass: "member__text"
  }, [_vm._v(_vm._s(_vm.name ? _vm.name : 'Без')), _c('br'), _vm._v(_vm._s(_vm.lastname ? _vm.lastname : 'Имени'))]), _c('p', {
    staticClass: "member__type"
  }, [_vm._v(_vm._s(_vm.typeText))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259b3b7e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/member/MentoringMember.vue
// module id = 5dcebba704ad46ad253a
// module chunks = 89